import os from 'os';
// RadAI Configuration
export const RadAIConfig = {
  // OpenAI Model Configuration
  model: {
    name: process.env.REACT_APP_RADAI_MODEL || "gpt-5.5",
    temperature: 0.2,
    maxTokens: 2000,
    topP: 1,
    frequencyPenalty: 0,
    presencePenalty: 0
  },

  api: {
    // Backend AI endpoints
    baseUrl: process.env.REACT_APP_RADAI_API_URL || "/api/v1/ai",
    
    // Request timeout
    timeout: 30000
  },

  // OCR Service Configuration
  ocr: {
    baseUrl: "https://172.20.15.157",
    endpoint: "/api/v1/mis/get-clarityai-file",
    timeout: 15000,
    retryAttempts: 2,
    retryDelay: 1000
  },

  // Chat Configuration
  chat: {
    maxMessages: 50,
    systemPrompt: "You are RadAI, an expert radiology assistant. Help with medical imaging interpretation and report generation.",
    welcomeMessage: "Hello! I'm RadAI, your radiology assistant. How can I help you today?"
  },

  // Claire Chat Configuration (for general AI assistant)
  claire: {
    maxMessages: 50,
    systemPrompt: "You are Claire, an experienced consultant radiologist practising in Australia, speaking to imaging professionals. Default to Australian practice (RANZCR, Medicare/MBS, TGA) unless asked about another country. Be crisp and direct: lead with the answer, keep responses short by default, expand only when the request genuinely requires it. No AI filler or closing offers of help. Precise radiological terminology, Australian English. Only medical imaging / radiology / healthcare topics.",
    welcomeMessage: "Hi! I'm Claire, your ClarityAI assistant. How can I help you today?"
  },

  // Report Templates
  templates: {
    default: {
      sections: ["CLINICAL HISTORY", "CLINICAL TECHNIQUE", "FINDINGS", "IMPRESSION"],
      format: "structured"
    }
  },

  // Report Generation Prompts
  prompts: {
    reportGeneration: {
      systemMessage: "You are a professional radiologist assistant. Generate structured radiology reports based on provided imaging data.",
      
      // Dynamic instruction - will be formatted with visit description
      instruction: "Build a radiology report for {visitDescription} in a clinical language within 300 words. Remove noise from the report input, if required. Please make sure you generate this report in Australian English.",
      temperature: 0.1,
      reportStructure: [
        {
          name: "Clinical History",
          description: "Leave as placeholder - will be inserted post-processing to avoid analysis bias"
        },
        {
          name: "Clinical Technique",
          description: "Brief description of the imaging technique used"
        },
        {
          name: "Findings",
          description: "Detailed findings in paragraph format"
        },
        {
          name: "Measurements",
          description: "Measurements in table format if applicable"
        },
        {
          name: "Impression",
          description: "Clinical impression for technician completion"
        },
        {
          name: "Conclusion",
          description: "Leave this section empty with placeholder text",
          placeholder: "[To be completed by a Radiologist]"
        }
      ],
      // Instructions for formatting
      formatting: {
        useSeparators: false,
        conclusionPlaceholder: "[To be completed by a Radiologist]"
      }
    }
  }
}; 